import ExploreWrapper from 'components/pages/explore/explorewrapper/ExploreWrapper';
import ExploreWrapperNew from 'components/pages/explore/explorewrappernew/ExploreWrapperNew';

import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import { NextSeo } from 'next-seo';

import useABTest from 'hooks/use-ab-test';
import { useRouter } from 'next/router';
import { COURSE_COUNT } from 'constants/site-stats.const';

const ExplorePage = () => {
	const seoProps = generateSeoProps({
		title: 'Pharmuni Courses: Explore Pharma Courses by Skill Level',
		description: `Browse ${COURSE_COUNT}+ ISO-backed GMP, QA & validation courses. Filter by topic or proficiency and enroll instantly to advance your pharmaceutical career.`,
		canonical: 'explore',
		noIndex: false
	});
	const router = useRouter();
	const { search_keyword } = router.query;
	// const { new_explore_test } = useABTest();

	return (
		<>
			<NextSeo {...seoProps} />
			{router.isReady && (
				<>
					{search_keyword ? (
						<ExploreWrapper />
					) : (
						<ExploreWrapperNew />
					)}
				</>
			)}



		</>
	);
};

export default ExplorePage;
